import React, { useEffect } from 'react';

const Blog8: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return (
        <article className="max-w-6xl mx-auto p-6 mt-28 bg-white shadow-lg rounded-lg mb-8">
            <h1 className="text-3xl font-bold mb-2">Head and Spine Trauma Recovery – From ER Dash to Thriving with Advanced Surgery</h1>
            <div className="text-gray-600 mb-4">
                🗓️ <span>1st March, 2026</span>
            </div>

            <img src='/images/blog8.png' alt="Head and Spine Trauma Recovery" className="w-full h-80 object-contain rounded-lg mb-6" />

            <div className="prose max-w-none">
                <p>
                    Neurotrauma requires urgent, systematic emergency management following motor vehicle collisions, falls, or acute sports injuries. Clinical red flags include altered sensorium, pupillary asymmetry, post-traumatic vomiting, focal motor deficits, and midline cervical or spinal tenderness. Emergency stabilization follows standard Advanced Trauma Life Support (ATLS) protocols, prioritizing airway protection, oxygenation, and hemodynamic stability before urgent CT imaging.
                </p>

                <h2 className="text-2xl font-semibold mt-6 mb-3">Surgical Intervention and Stabilization</h2>
                <p>
                    Surgical indications depend on imaging findings and intracranial pressure dynamics. Traumatic mass lesions such as acute subdural hematomas or epidural hematomas may necessitate emergency craniotomy or decompressive craniectomy. For unstable spinal fractures or subluxations, surgical stabilization via neuronavigated instrumentation supports neural canal decompression and spinal alignment.
                </p>

                <h2 className="text-2xl font-semibold mt-6 mb-3">Rehabilitation and Long-Term Recovery</h2>
                <p>
                    Neurotrauma recovery is a multidisciplinary process extending beyond acute surgical intervention. Care in a dedicated Neuro-ICU is integrated with early physical therapy, occupational therapy, and cognitive rehabilitation. Milestones and recovery timelines vary based on initial injury severity, age, and neurological status.
                </p>

                <h2 className="text-2xl font-semibold mt-6 mb-3">Comprehensive Neurotrauma Care</h2>
                <p>
                    Comprehensive management combines prompt emergency intervention, precision microsurgical techniques, and coordinated rehabilitation to optimize functional recovery pathways following severe cranial and spinal trauma.
                </p>
            </div>

            <button className="mt-6 bg-blue-800 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded">
                Schedule Appointment
            </button>
        </article>
    );
};

export default Blog8;
